<template>
  <div class="v-inbox-wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: "VInboxWrapper"
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";
@import "./v-inbox-wrapper.scss";
</style>
